import { render, staticRenderFns } from "./vermittlungsuebersicht-nav.vue?vue&type=template&id=38767c08&"
import script from "./vermittlungsuebersicht-nav.vue?vue&type=script&lang=js&"
export * from "./vermittlungsuebersicht-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports